
















import Vue from "vue";
import { required } from "vuelidate/lib/validators";
import permission, { PermissionName } from "@/common/mixins/permission";
import dialog from "@/common/mixins/dialog";
import ShopifyEditorForm from "../components/ShopifyEditorForm.vue";
import { ShopifyUpdateForm } from "../forms/ShopifyUpdateForm";
import { Shop } from "../../shop/models/Shop";
import { DeliveryMode } from "../../delivery-modes/models/DeliveryMode";
export default Vue.extend({
  mixins: [permission, dialog],
  components: {
    ShopifyEditorForm
  },
  validations: {
    shopifyUpdateForm: {
      shop: { required },
      deliveryMode: { required },
      shopName: { required },
      token: { required },
      hostname: { required },
      mcApiKey: { required },
      mcSecretkey: { required },
      locationId: { required }
    }
  },
  data() {
    const shops: Shop[] = [];
    const deliveryMode: DeliveryMode[] = [];
    const shopifyUpdateForm: ShopifyUpdateForm = {
      shopName: "",
      token: "",
      hostname: "",
      mcApiKey: "",
      mcSecretkey: "",
      locationId: ""
    };
    return { shopifyUpdateForm, shops, deliveryMode };
  },
  async created() {
    await Promise.all([this.getShops()]);
    await this.getShopifyById(+this.$route.params.id);
    await this.getDeliveryModesByShopId(this.shopifyUpdateForm.shop?.id!).then(
      () => {
        this.setInitDeliveryMode();
      }
    );
  },
  methods: {
    async getDeliveryModesByShopId(shopId: number) {
      try {
        const {
          data
        } = await (this as any).$dep.deliveryModeUseCase.getDeliveryModesByShopId(
          shopId
        );
        this.deliveryMode = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    setInitDeliveryMode() {
      const deliveryMode = this.deliveryMode.find(delivery => {
        return delivery.id == this.shopifyUpdateForm.deliveryModeId!;
      });

      this.shopifyUpdateForm = { ...this.shopifyUpdateForm, deliveryMode };
    },
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    goToShopifyViewPage() {
      this.$router.push({ name: "ShopifyViewPage" });
    },
    async getShopifyById(id: number) {
      try {
        const { data } = await (this as any).$dep.shopifyUseCase.getShopifyById(
          id
        );
        const shop = this.shops.find(shop => {
          return shop.id === data.shopId;
        });

        this.shopifyUpdateForm = { ...data, shop };
      } catch (error) {
        console.log(error);
      }
    },
    async updateShopify(id: number) {
      try {
        await (this as any).$dep.shopifyUseCase.updateShopify(
          id,
          this.shopifyUpdateForm
        );
        if (
          await (this as any).alertSuccess("Success", "Update Shopify สำเร็จ")
        ) {
          this.goToShopifyViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError(
                "Error",
                "ไม่สามารถ Update Shopify นี้ได้"
              )
            : (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to update Shopify",
        "คุณต้องการ Update Shopify หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.updateShopify(+this.$route.params.id);
      }
    },
    clear() {
      this.$v.$reset();
      this.shopifyUpdateForm = {
        shopName: "",
        token: "",
        hostname: "",
        mcApiKey: "",
        mcSecretkey: "",
        locationId: ""
      };
    }
  }
});
